import { orderSave } from './../api';
const finance = {
  namespaced: true,
  state: {
    successCode: 200,
    orderSaveObj: null,
    marketObj: null,
    expensesAreasOptionObj: null
  },
  mutations: {

  },
  actions: {

  }
}
export default finance



// WEBPACK FOOTER //
// ./src/page/zhubo/finance/store/finance.store.js